import React, {useState, useEffect} from "react";
import {Row, Col} from "react-bootstrap";
import axios from "axios";
import {useHistory} from "react-router-dom";

function CreateKpis() {
    const uriTypeParam = "https://bo.influxs.live/StraKingAPI00X/api/actions_params";
    const uriCreateKpis = "https://bo.influxs.live/StraKingAPI00X/api/new_actionkpi";
    const uriForUpload = "https://bo.influxs.live/StraKingAPI00X/api/new_actionfile";
    const [kpisType, setKpisType] = useState(null);
    const [kpiTypeSelected, setkpiTypeSelected] = useState({id: ""});
    const [loading, setLoading] = useState(false);

    const [loadingUpload, setLoadingUpload] = useState(false);

    const [selectedFile, setSelectedFile] = useState({selectedFile:''});

    const  handleInputChange = event => {
        setSelectedFile({...selectedFile, selectedFile: event.target.files[0]})
    }

    const [error, setError] = useState("");
    const [errorUpload, setErrorUpload] = useState("");
    let history=useHistory();
    const [createKpis, setCreateKpis] = useState({
        idAction: "",
        idKpisType: "",
        numberOfKpis: "",
    });
    useEffect(() => {
        const token = localStorage.getItem('token');
        const contraId = localStorage.getItem('contraId');
        console.log(contraId);
        const api = axios.create({
            baseURL: uriTypeParam,
            headers: {'Authorization': 'Bearer ' + token}
        });

        getTypeParams();


        async function getTypeParams() {
            api.get(uriTypeParam + "/" + contraId).then(
                res => {
                    console.log(res);
                    setKpisType(res.data.kpis);
                }
            ).catch(err => {
                alert(err.response.data.message);
            })

        }
    }, []);
    const submitHandler = e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const actionId = localStorage.getItem('actionId');
        const api = axios.create({
            baseURL: uriCreateKpis,
            headers: {'Authorization': 'Bearer ' + token}
        });
        setError("");
        setLoading(true);
        if(actionId !=="" &&
            createKpis.idKpisType !== "" &&
            createKpis.numberOfKpis !== "") {
            const dataToCreateKpis = {
                action:actionId,
                kpi:createKpis.idKpisType,
                value:createKpis.numberOfKpis
            };
            api.post(uriCreateKpis,dataToCreateKpis).then(
                res=>{
                    console.log(res);
                    setLoading(false);
                    alert("Kpi Mis a jour avec succès");
                    setCreateKpis({...createKpis,
                        idKpisType: "",
                        idAction: "",
                        numberOfKpis: ""
                    });
                }
            ).catch(err =>{
                setError(err.response.data.message);
                alert(err.response.data.message);
                setLoading(false);
            })
        }else{
            setLoading(false);
            setError("Renseignez votre les champs vide !!!");
        }
    }

    const submitHandlerForUpload = e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        const actionId = localStorage.getItem('actionId');
        const api = axios.create({
            baseURL: uriForUpload,
            headers: {'Authorization': 'Bearer ' + token}
        });
        setErrorUpload("");
        setLoadingUpload(true);
        const data = new FormData();

        console.log(selectedFile.selectedFile);
        if(actionId !=="" &&
            selectedFile.selectedFile !== "") {
            data.append('file', selectedFile.selectedFile)
            data.append('action', actionId);
            api.post(uriForUpload,data).then(
                res=>{
                    console.log(res);
                    setLoadingUpload(false);
                    alert("Fichier Importé avec succès");
                    setSelectedFile({...selectedFile, selectedFile: ""});
                }
            ).catch(err =>{
                setErrorUpload(err.response.data.message);
                alert(err.response.data.message);
                setLoadingUpload(false);
            })
        }else{
            setLoadingUpload(false);
            setErrorUpload("Renseignez votre les champs vide !!!");
        }
    }

    const stateSelectionHandlerKpisTypes = event => {
        const value = event.target.value;
        console.log("id: " + value);
        setCreateKpis({...createKpis, idKpisType: value});
        setkpiTypeSelected({...kpiTypeSelected, id: value});
        const stateIndex = kpisType.findIndex(state => state.value === value);
        console.log(event.target.value, kpisType, "index:", stateIndex);
        console.log("id product: " + kpiTypeSelected.id);
    };
    return (
        <div>
            <Row>
                <Col>
                    <div className="login_form">
                        <form onSubmit={submitHandler}>
                            <div className="form-inner">
                                <Row>
                                    <Col>
                                        <button className="button" onClick={() => {
                                            history.push('/contraDetails');
                                        }}> retour</button>
                                    </Col>
                                    <Col>
                                        <h2>Mise a jour des Kpis</h2>
                                    </Col>
                                </Row>
                                {(error!=="") ? (<div className="error">{error}</div>) : ""}
                                {loading ? (<div className="loader">Loading ....</div>) :(<div></div>)}
                                <div className="form-group">
                                    <label htmlFor="action">Choix du Kpis</label>
                                    <select onChange={stateSelectionHandlerKpisTypes}>
                                        {
                                            (kpisType && kpisType.length > 0) && kpisType.map((schema, index) => {
                                                return (<option value={schema.id} key={index}> {schema.label}</option>);
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="link">Numbre de Kpi</label>
                                    <input type="number" name="kpisNumber"
                                           id="kpisNumber"
                                           onChange={e => setCreateKpis({...createKpis, numberOfKpis: e.target.value})}
                                           value={createKpis.numberOfKpis}/>
                                </div>
                                <input type="submit" value="Valider"/>
                            </div>

                        </form>
                    </div>
                </Col>
                <Col>
                    <div className="login_form">
                        <form onSubmit={submitHandlerForUpload}>
                            {(errorUpload!=="") ? (<div className="error">{errorUpload}</div>) : ""}
                            {loadingUpload ? (<div className="loader">Loading ....</div>) :(<div></div>)}
                            <div className="form-inner">
                                        <h2>Joindre un fichier</h2>
                                {(errorUpload!=="") ? (<div className="error">{errorUpload}</div>) : ""}
                                {loadingUpload ? (<div className="loader">Loading ....</div>) :(<div></div>)}
                                <div className="form-group">
                                    <label htmlFor="link">fichier</label>
                                    <input type="file" name="file"
                                           id="file"  onChange={handleInputChange}/>
                                </div>
                                <input type="submit" value="Valider" />
                            </div>

                        </form>
                    </div>
                </Col>
            </Row>
        </div>

    )
}

export default CreateKpis;